import { useRouteError } from 'react-router-dom'

export default function Error() {
    const error = useRouteError();
  return (
    <h1>
      something went wrong. {error.status}
    </h1>
  )
}